import { useDOMPurify } from '../../lib/useDOMPurify';

interface BenefitProps {
	title: string;
	description: string;
	imageSrc: string;
	className?: string;
}

export const Benefit: React.FC<BenefitProps> = ({
	title,
	description,
	imageSrc,
	className,
}) => {
	const sanitizedContent = useDOMPurify(description);

	return (
		<div className={`min-w-[225px] max-w-[225px] ${className ?? ''}`}>
			<img src={imageSrc} alt={title} className="rounded-sm mb-8" />
			<h2 className="text-xl mb-4">{title}</h2>
			<p
				className="text-gray-600"
				dangerouslySetInnerHTML={{ __html: sanitizedContent }}
			/>
		</div>
	);
};
